// Generated by purs version 0.15.16
import * as Bound from "../Bound/index.js";
import * as Codensity from "../Codensity/index.js";
import * as Control_Alt from "../Control.Alt/index.js";
import * as Control_Applicative from "../Control.Applicative/index.js";
import * as Control_Apply from "../Control.Apply/index.js";
import * as Control_Bind from "../Control.Bind/index.js";
import * as Control_Category from "../Control.Category/index.js";
import * as Control_Monad from "../Control.Monad/index.js";
import * as Control_Monad_State_Class from "../Control.Monad.State.Class/index.js";
import * as Control_Plus from "../Control.Plus/index.js";
import * as Data_Const from "../Data.Const/index.js";
import * as Data_Coyoneda from "../Data.Coyoneda/index.js";
import * as Data_Either from "../Data.Either/index.js";
import * as Data_Eq from "../Data.Eq/index.js";
import * as Data_Exists from "../Data.Exists/index.js";
import * as Data_Foldable from "../Data.Foldable/index.js";
import * as Data_Function from "../Data.Function/index.js";
import * as Data_Functor from "../Data.Functor/index.js";
import * as Data_Functor_Compose from "../Data.Functor.Compose/index.js";
import * as Data_Generic_Rep from "../Data.Generic.Rep/index.js";
import * as Data_Identity from "../Data.Identity/index.js";
import * as Data_Maybe from "../Data.Maybe/index.js";
import * as Data_Newtype from "../Data.Newtype/index.js";
import * as Data_Profunctor from "../Data.Profunctor/index.js";
import * as Data_Profunctor_Strong from "../Data.Profunctor.Strong/index.js";
import * as Data_Semigroup from "../Data.Semigroup/index.js";
import * as Data_Show from "../Data.Show/index.js";
import * as Data_Show_Generic from "../Data.Show.Generic/index.js";
import * as Data_Traversable from "../Data.Traversable/index.js";
import * as Data_Tuple from "../Data.Tuple/index.js";
import * as Data_Unit from "../Data.Unit/index.js";
import * as Data_Void from "../Data.Void/index.js";
import * as Expr from "../Expr/index.js";
import * as FixFunctor from "../FixFunctor/index.js";
import * as Halogen_Component from "../Halogen.Component/index.js";
import * as Halogen_HTML_Core from "../Halogen.HTML.Core/index.js";
import * as Halogen_HTML_Elements from "../Halogen.HTML.Elements/index.js";
import * as Halogen_HTML_Properties from "../Halogen.HTML.Properties/index.js";
import * as Halogen_Query_HalogenM from "../Halogen.Query.HalogenM/index.js";
import * as Matryoshka_Class_Corecursive from "../Matryoshka.Class.Corecursive/index.js";
import * as Matryoshka_Class_Recursive from "../Matryoshka.Class.Recursive/index.js";
import * as Matryoshka_Fold from "../Matryoshka.Fold/index.js";
import * as Ran from "../Ran/index.js";
var $runtime_lazy = function (name, moduleName, init) {
    var state = 0;
    var val;
    return function (lineNumber) {
        if (state === 2) return val;
        if (state === 1) throw new ReferenceError(name + " was needed before it finished initializing (module " + moduleName + ", line " + lineNumber + ")", moduleName, lineNumber);
        state = 1;
        val = init();
        state = 2;
        return val;
    };
};
var unwrap = /* #__PURE__ */ Data_Newtype.unwrap();
var hoistScope = /* #__PURE__ */ Bound.hoistScope(Data_Coyoneda.functorCoyoneda);
var showRecord = /* #__PURE__ */ Data_Show.showRecord()();
var showRecordFieldsCons = /* #__PURE__ */ Data_Show.showRecordFieldsCons({
    reflectSymbol: function () {
        return "argument";
    }
});
var showRecordFieldsConsNil = /* #__PURE__ */ Data_Show.showRecordFieldsConsNil({
    reflectSymbol: function () {
        return "function";
    }
});
var ApplicationIsSymbol = {
    reflectSymbol: function () {
        return "Application";
    }
};
var showRecordFieldsCons1 = /* #__PURE__ */ Data_Show.showRecordFieldsCons({
    reflectSymbol: function () {
        return "body";
    }
})(/* #__PURE__ */ Data_Show.showRecordFieldsConsNil({
    reflectSymbol: function () {
        return "variableName";
    }
})(Data_Show.showString));
var showScope = /* #__PURE__ */ Bound.showScope(Data_Show.showUnit);
var showVar = /* #__PURE__ */ Bound.showVar(Data_Show.showUnit);
var AbstractionIsSymbol = {
    reflectSymbol: function () {
        return "Abstraction";
    }
};
var FreeVariableIsSymbol = {
    reflectSymbol: function () {
        return "FreeVariable";
    }
};
var lcmap = /* #__PURE__ */ Data_Profunctor.lcmap(Data_Profunctor.profunctorFn);
var map = /* #__PURE__ */ Data_Functor.map(/* #__PURE__ */ Bound.functorScope(Data_Coyoneda.functorCoyoneda));
var identity = /* #__PURE__ */ Control_Category.identity(Control_Category.categoryFn);
var eqScope = /* #__PURE__ */ Bound.eqScope(Data_Eq.eqUnit);
var eqVar = /* #__PURE__ */ Bound.eqVar(Data_Eq.eqUnit);
var subst = /* #__PURE__ */ Bound.subst(Bound.boundScope);
var show = /* #__PURE__ */ Data_Show.show(Data_Show.showInt);
var map1 = /* #__PURE__ */ Data_Functor.map(Data_Either.functorEither);
var first = /* #__PURE__ */ Data_Profunctor_Strong.first(Data_Profunctor_Strong.strongFn);
var discard = /* #__PURE__ */ Control_Bind.discard(Control_Bind.discardUnit)(Halogen_Query_HalogenM.bindHalogenM);
var put = /* #__PURE__ */ Control_Monad_State_Class.put(Halogen_Query_HalogenM.monadStateHalogenM);
var pure = /* #__PURE__ */ Control_Applicative.pure(Halogen_Query_HalogenM.applicativeHalogenM);
var pure1 = /* #__PURE__ */ Control_Applicative.pure(Control_Applicative.applicativeArray);
var eq1 = /* #__PURE__ */ Data_Eq.eq(Expr.eqExpr);
var MkRan = function (x) {
    return x;
};
var MkNComp = function (x) {
    return x;
};
var MkLanF = function (x) {
    return x;
};
var MkLan = function (x) {
    return x;
};
var MkDensity = function (x) {
    return x;
};
var MkCodensity = function (x) {
    return x;
};
var Application = /* #__PURE__ */ (function () {
    function Application(value0) {
        this.value0 = value0;
    };
    Application.create = function (value0) {
        return new Application(value0);
    };
    return Application;
})();
var Abstraction = /* #__PURE__ */ (function () {
    function Abstraction(value0) {
        this.value0 = value0;
    };
    Abstraction.create = function (value0) {
        return new Abstraction(value0);
    };
    return Abstraction;
})();
var FreeVariable = /* #__PURE__ */ (function () {
    function FreeVariable(value0) {
        this.value0 = value0;
    };
    FreeVariable.create = function (value0) {
        return new FreeVariable(value0);
    };
    return FreeVariable;
})();
var BoundsCheck = /* #__PURE__ */ (function () {
    function BoundsCheck(value0, value1) {
        this.value0 = value0;
        this.value1 = value1;
    };
    BoundsCheck.create = function (value0) {
        return function (value1) {
            return new BoundsCheck(value0, value1);
        };
    };
    return BoundsCheck;
})();
var AppF = /* #__PURE__ */ (function () {
    function AppF(value0) {
        this.value0 = value0;
    };
    AppF.create = function (value0) {
        return new AppF(value0);
    };
    return AppF;
})();
var AbsF = /* #__PURE__ */ (function () {
    function AbsF(value0) {
        this.value0 = value0;
    };
    AbsF.create = function (value0) {
        return new AbsF(value0);
    };
    return AbsF;
})();
var VarF = /* #__PURE__ */ (function () {
    function VarF(value0) {
        this.value0 = value0;
    };
    VarF.create = function (value0) {
        return new VarF(value0);
    };
    return VarF;
})();
var newtypeNComp_ = {
    Coercible0: function () {
        return undefined;
    }
};
var hFunctorNComp = function (dictFunctor) {
    var map5 = Data_Functor.map(dictFunctor);
    return {
        hmap: function (nt) {
            var $513 = map5(nt);
            return function ($514) {
                return MkNComp(Data_Functor_Compose.Compose($513(unwrap(unwrap($514)))));
            };
        }
    };
};
var nestedConstNComp = function (dictRecursive) {
    var project = Matryoshka_Class_Recursive.project(dictRecursive);
    return function (dictCorecursive) {
        var Functor0 = dictCorecursive.Functor0();
        var map5 = Data_Functor.map(Functor0);
        var hFunctorNComp1 = hFunctorNComp(Functor0);
        return {
            hproject: (function () {
                var $515 = map5(Data_Const.Const);
                return function ($516) {
                    return MkNComp(Data_Functor_Compose.Compose($515(project(unwrap($516)))));
                };
            })(),
            hembed: (function () {
                var $517 = Matryoshka_Class_Corecursive.embed(dictCorecursive);
                var $518 = map5(unwrap);
                return function ($519) {
                    return Data_Const.Const($517($518(unwrap(unwrap($519)))));
                };
            })(),
            HFunctor0: function () {
                return hFunctorNComp1;
            }
        };
    };
};
var hFunctorBExprF = {
    hmap: function (f) {
        var h = function (v) {
            if (v instanceof AppF) {
                return new AppF({
                    "function": f(v["value0"]["function"]),
                    argument: f(v.value0.argument)
                });
            };
            if (v instanceof AbsF) {
                return new AbsF({
                    variableName: v.value0.variableName,
                    body: hoistScope(Data_Coyoneda.hoistCoyoneda(f))(v.value0.body)
                });
            };
            if (v instanceof VarF) {
                return new VarF(v.value0);
            };
            throw new Error("Failed pattern match at Bounded (line 107, column 5 - line 107, column 73): " + [ v.constructor.name ]);
        };
        return h;
    }
};
var genericNComp_ = {
    to: function (x) {
        return x;
    },
    from: function (x) {
        return x;
    }
};
var genericBExpr_ = {
    to: function (x) {
        if (x instanceof Data_Generic_Rep.Inl) {
            return new Application(x.value0);
        };
        if (x instanceof Data_Generic_Rep.Inr && x.value0 instanceof Data_Generic_Rep.Inl) {
            return new Abstraction(x.value0.value0);
        };
        if (x instanceof Data_Generic_Rep.Inr && x.value0 instanceof Data_Generic_Rep.Inr) {
            return new FreeVariable(x.value0.value0);
        };
        throw new Error("Failed pattern match at Bounded (line 63, column 1 - line 63, column 36): " + [ x.constructor.name ]);
    },
    from: function (x) {
        if (x instanceof Application) {
            return new Data_Generic_Rep.Inl(x.value0);
        };
        if (x instanceof Abstraction) {
            return new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inl(x.value0));
        };
        if (x instanceof FreeVariable) {
            return new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(x.value0));
        };
        throw new Error("Failed pattern match at Bounded (line 63, column 1 - line 63, column 36): " + [ x.constructor.name ]);
    }
};
var genericShow = /* #__PURE__ */ Data_Show_Generic.genericShow(genericBExpr_);
var showBExpr = function (dictShow) {
    var genericShowConstructor = Data_Show_Generic.genericShowConstructor(Data_Show_Generic.genericShowArgsArgument(dictShow))(FreeVariableIsSymbol);
    return {
        show: function (x) {
            return genericShow(Data_Show_Generic.genericShowSum(Data_Show_Generic.genericShowConstructor(Data_Show_Generic.genericShowArgsArgument(showRecord(showRecordFieldsCons(showRecordFieldsConsNil(showBExpr(dictShow)))(showBExpr(dictShow)))))(ApplicationIsSymbol))(Data_Show_Generic.genericShowSum(Data_Show_Generic.genericShowConstructor(Data_Show_Generic.genericShowArgsArgument(showRecord(showRecordFieldsCons1(showScope(showBExpr(showVar(showBExpr(dictShow))))(dictShow)))))(AbstractionIsSymbol))(genericShowConstructor)))(x);
        }
    };
};
var genericBExprF_ = {
    to: function (x) {
        if (x instanceof Data_Generic_Rep.Inl) {
            return new AppF(x.value0);
        };
        if (x instanceof Data_Generic_Rep.Inr && x.value0 instanceof Data_Generic_Rep.Inl) {
            return new AbsF(x.value0.value0);
        };
        if (x instanceof Data_Generic_Rep.Inr && x.value0 instanceof Data_Generic_Rep.Inr) {
            return new VarF(x.value0.value0);
        };
        throw new Error("Failed pattern match at Bounded (line 97, column 1 - line 97, column 39): " + [ x.constructor.name ]);
    },
    from: function (x) {
        if (x instanceof AppF) {
            return new Data_Generic_Rep.Inl(x.value0);
        };
        if (x instanceof AbsF) {
            return new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inl(x.value0));
        };
        if (x instanceof VarF) {
            return new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(x.value0));
        };
        throw new Error("Failed pattern match at Bounded (line 97, column 1 - line 97, column 39): " + [ x.constructor.name ]);
    }
};
var functorRan = {
    map: function (f) {
        return function (m) {
            return lcmap(lcmap(f))(m);
        };
    }
};
var functorNComp = function (dictFunctor) {
    var functorCompose = Data_Functor_Compose.functorCompose(dictFunctor);
    return function (dictFunctor1) {
        var map5 = Data_Functor.map(functorCompose(dictFunctor1));
        return {
            map: function (f) {
                return function (m) {
                    return map5(f)(m);
                };
            }
        };
    };
};
var functorCodensity = {
    map: function (f) {
        return function (m) {
            return lcmap(lcmap(f))(m);
        };
    }
};
var lowerCoyoneda = /* #__PURE__ */ Data_Coyoneda.lowerCoyoneda(functorCodensity);
var functorBExprF = function (dictFunctor) {
    var map5 = Data_Functor.map(dictFunctor);
    return {
        map: function (f) {
            return function (m) {
                if (m instanceof AppF) {
                    return new AppF({
                        argument: map5(f)(m.value0.argument),
                        "function": map5(f)(m["value0"]["function"])
                    });
                };
                if (m instanceof AbsF) {
                    return new AbsF({
                        variableName: m.value0.variableName,
                        body: map(f)(m.value0.body)
                    });
                };
                if (m instanceof VarF) {
                    return new VarF(f(m.value0));
                };
                throw new Error("Failed pattern match at Bounded (line 0, column 0 - line 0, column 0): " + [ m.constructor.name ]);
            };
        }
    };
};
var functorBExpr = {
    map: function (f) {
        return function (m) {
            if (m instanceof Application) {
                return new Application({
                    argument: Data_Functor.map(functorBExpr)(f)(m.value0.argument),
                    "function": Data_Functor.map(functorBExpr)(f)(m["value0"]["function"])
                });
            };
            if (m instanceof Abstraction) {
                return new Abstraction({
                    variableName: m.value0.variableName,
                    body: Data_Functor.map(Bound.functorScope(functorBExpr))(f)(m.value0.body)
                });
            };
            if (m instanceof FreeVariable) {
                return new FreeVariable(f(m.value0));
            };
            throw new Error("Failed pattern match at Bounded (line 0, column 0 - line 0, column 0): " + [ m.constructor.name ]);
        };
    }
};
var hoistScope1 = /* #__PURE__ */ Bound.hoistScope(functorBExpr);
var lowerCoyoneda1 = /* #__PURE__ */ Data_Coyoneda.lowerCoyoneda(functorBExpr);
var map2 = /* #__PURE__ */ Data_Functor.map(functorBExpr);
var nestedBExprBExprF = {
    hproject: function (v) {
        if (v instanceof Application) {
            return new AppF(v.value0);
        };
        if (v instanceof Abstraction) {
            return new AbsF({
                variableName: v.value0.variableName,
                body: hoistScope1(Data_Coyoneda.liftCoyoneda)(v.value0.body)
            });
        };
        if (v instanceof FreeVariable) {
            return new VarF(v.value0);
        };
        throw new Error("Failed pattern match at Bounded (line 159, column 1 - line 166, column 35): " + [ v.constructor.name ]);
    },
    hembed: function (v) {
        if (v instanceof AppF) {
            return new Application(v.value0);
        };
        if (v instanceof AbsF) {
            return new Abstraction({
                variableName: v.value0.variableName,
                body: hoistScope(lowerCoyoneda1)(v.value0.body)
            });
        };
        if (v instanceof VarF) {
            return new FreeVariable(v.value0);
        };
        throw new Error("Failed pattern match at Bounded (line 159, column 1 - line 166, column 35): " + [ v.constructor.name ]);
    },
    HFunctor0: function () {
        return hFunctorBExprF;
    }
};
var foldableBExpr = {
    foldl: function (f) {
        return function (z) {
            return function (m) {
                if (m instanceof Application) {
                    return Data_Foldable.foldl(foldableBExpr)(f)(Data_Foldable.foldl(foldableBExpr)(f)(z)(m.value0.argument))(m["value0"]["function"]);
                };
                if (m instanceof Abstraction) {
                    return Data_Foldable.foldl(Bound.foldableScope(foldableBExpr))(f)(z)(m.value0.body);
                };
                if (m instanceof FreeVariable) {
                    return f(z)(m.value0);
                };
                throw new Error("Failed pattern match at Bounded (line 0, column 0 - line 0, column 0): " + [ m.constructor.name ]);
            };
        };
    },
    foldr: function (f) {
        return function (z) {
            return function (m) {
                if (m instanceof Application) {
                    return Data_Foldable.foldr(foldableBExpr)(f)(Data_Foldable.foldr(foldableBExpr)(f)(z)(m["value0"]["function"]))(m.value0.argument);
                };
                if (m instanceof Abstraction) {
                    return Data_Foldable.foldr(Bound.foldableScope(foldableBExpr))(f)(z)(m.value0.body);
                };
                if (m instanceof FreeVariable) {
                    return f(m.value0)(z);
                };
                throw new Error("Failed pattern match at Bounded (line 0, column 0 - line 0, column 0): " + [ m.constructor.name ]);
            };
        };
    },
    foldMap: function (dictMonoid) {
        var append1 = Data_Semigroup.append(dictMonoid.Semigroup0());
        return function (f) {
            return function (m) {
                if (m instanceof Application) {
                    return append1(Data_Foldable.foldMap(foldableBExpr)(dictMonoid)(f)(m.value0.argument))(Data_Foldable.foldMap(foldableBExpr)(dictMonoid)(f)(m["value0"]["function"]));
                };
                if (m instanceof Abstraction) {
                    return Data_Foldable.foldMap(Bound.foldableScope(foldableBExpr))(dictMonoid)(f)(m.value0.body);
                };
                if (m instanceof FreeVariable) {
                    return f(m.value0);
                };
                throw new Error("Failed pattern match at Bounded (line 0, column 0 - line 0, column 0): " + [ m.constructor.name ]);
            };
        };
    }
};
var traversableBExpr = {
    traverse: function (dictApplicative) {
        var Apply0 = dictApplicative.Apply0();
        var apply = Control_Apply.apply(Apply0);
        var map5 = Data_Functor.map(Apply0.Functor0());
        return function (f) {
            return function (m) {
                if (m instanceof Application) {
                    return apply(map5(function (v1) {
                        return function (v2) {
                            return new Application({
                                argument: v1,
                                "function": v2
                            });
                        };
                    })(Data_Traversable.traverse(traversableBExpr)(dictApplicative)(f)(m.value0.argument)))(Data_Traversable.traverse(traversableBExpr)(dictApplicative)(f)(m["value0"]["function"]));
                };
                if (m instanceof Abstraction) {
                    return map5(function (v1) {
                        return new Abstraction({
                            variableName: m.value0.variableName,
                            body: v1
                        });
                    })(Data_Traversable.traverse(Bound.traversableScope(traversableBExpr))(dictApplicative)(f)(m.value0.body));
                };
                if (m instanceof FreeVariable) {
                    return map5(function (v1) {
                        return new FreeVariable(v1);
                    })(f(m.value0));
                };
                throw new Error("Failed pattern match at Bounded (line 0, column 0 - line 0, column 0): " + [ m.constructor.name ]);
            };
        };
    },
    sequence: function (dictApplicative) {
        return function (v) {
            return Data_Traversable.traverse(traversableBExpr)(dictApplicative)(identity)(v);
        };
    },
    Functor0: function () {
        return functorBExpr;
    },
    Foldable1: function () {
        return foldableBExpr;
    }
};
var fFunctorBExprF = {
    fmap: function (dictFunctor) {
        var map5 = Data_Functor.map(dictFunctor);
        return function (f) {
            var x = function (v) {
                if (v instanceof AppF) {
                    return new AppF({
                        "function": map5(f)(v["value0"]["function"]),
                        argument: map5(f)(v.value0.argument)
                    });
                };
                if (v instanceof AbsF) {
                    return new AbsF({
                        variableName: v.value0.variableName,
                        body: map(f)(v.value0.body)
                    });
                };
                if (v instanceof VarF) {
                    return new VarF(f(v.value0));
                };
                throw new Error("Failed pattern match at Bounded (line 330, column 5 - line 330, column 81): " + [ v.constructor.name ]);
            };
            return x;
        };
    }
};
var eqNComp = function (dictEq1) {
    var eqCompose = Data_Functor_Compose.eqCompose(dictEq1);
    return function (dictEq11) {
        var eqCompose1 = eqCompose(dictEq11);
        return function (dictEq) {
            var eq2 = Data_Eq.eq(eqCompose1(dictEq));
            return {
                eq: function (x) {
                    return function (y) {
                        return eq2(x)(y);
                    };
                }
            };
        };
    };
};
var eqBExprF = function (dictEq1) {
    var eq11 = Data_Eq.eq1(dictEq1);
    return function (dictFunctor) {
        var eqScope1 = eqScope(Data_Coyoneda.eq1Coyoneda(dictFunctor)(dictEq1));
        var eqCoyoneda = Data_Coyoneda.eqCoyoneda(dictFunctor)(dictEq1);
        return function (dictEq) {
            var eq12 = eq11(dictEq);
            var eqCoyoneda1 = eqCoyoneda(dictEq);
            var eq2 = Data_Eq.eq(eqScope1(eqCoyoneda1)(eqCoyoneda(eqVar(eqCoyoneda1)))(dictEq));
            var eq3 = Data_Eq.eq(dictEq);
            return {
                eq: function (x) {
                    return function (y) {
                        if (x instanceof AppF && y instanceof AppF) {
                            return eq12(x.value0.argument)(y.value0.argument) && eq12(x["value0"]["function"])(y["value0"]["function"]);
                        };
                        if (x instanceof AbsF && y instanceof AbsF) {
                            return eq2(x.value0.body)(y.value0.body) && x.value0.variableName === y.value0.variableName;
                        };
                        if (x instanceof VarF && y instanceof VarF) {
                            return eq3(x.value0)(y.value0);
                        };
                        return false;
                    };
                }
            };
        };
    };
};
var eq1NComp = function (dictEq1) {
    var eqNComp1 = eqNComp(dictEq1);
    return function (dictEq11) {
        var eqNComp2 = eqNComp1(dictEq11);
        return {
            eq1: function (dictEq) {
                return Data_Eq.eq(eqNComp2(dictEq));
            }
        };
    };
};
var eq1BExprF = function (dictEq1) {
    var eqBExprF1 = eqBExprF(dictEq1);
    return function (dictFunctor) {
        var eqBExprF2 = eqBExprF1(dictFunctor);
        return {
            eq1: function (dictEq) {
                return Data_Eq.eq(eqBExprF2(dictEq));
            }
        };
    };
};
var eqBExpr = function (dictEq) {
    var eq2 = Data_Eq.eq(dictEq);
    return {
        eq: function (x) {
            return function (y) {
                if (x instanceof Application && y instanceof Application) {
                    return Data_Eq.eq(eqBExpr(dictEq))(x.value0.argument)(y.value0.argument) && Data_Eq.eq(eqBExpr(dictEq))(x["value0"]["function"])(y["value0"]["function"]);
                };
                if (x instanceof Abstraction && y instanceof Abstraction) {
                    return Data_Eq.eq(eqScope(eq1BExpr)(eqBExpr(dictEq))(eqBExpr(eqVar(eqBExpr(dictEq))))(dictEq))(x.value0.body)(y.value0.body) && x.value0.variableName === y.value0.variableName;
                };
                if (x instanceof FreeVariable && y instanceof FreeVariable) {
                    return eq2(x.value0)(y.value0);
                };
                return false;
            };
        }
    };
};
var eq1BExpr = {
    eq1: function (dictEq) {
        return Data_Eq.eq(eqBExpr(dictEq));
    }
};
var applyNComp = function (dictApply) {
    var applyCompose = Data_Functor_Compose.applyCompose(dictApply);
    var functorNComp1 = functorNComp(dictApply.Functor0());
    return function (dictApply1) {
        var apply = Control_Apply.apply(applyCompose(dictApply1));
        var functorNComp2 = functorNComp1(dictApply1.Functor0());
        return {
            apply: function (f) {
                return function (x) {
                    return apply(unwrap(f))(unwrap(x));
                };
            },
            Functor0: function () {
                return functorNComp2;
            }
        };
    };
};
var applicativeNComp = function (dictApplicative) {
    var pure3 = Control_Applicative.pure(dictApplicative);
    var applyNComp1 = applyNComp(dictApplicative.Apply0());
    return function (dictApplicative1) {
        var applyNComp2 = applyNComp1(dictApplicative1.Apply0());
        return {
            pure: (function () {
                var $520 = Control_Applicative.pure(dictApplicative1);
                return function ($521) {
                    return MkNComp(Data_Functor_Compose.Compose(pure3($520($521))));
                };
            })(),
            Apply0: function () {
                return applyNComp2;
            }
        };
    };
};
var monadBExpr = {
    Applicative0: function () {
        return applicativeBExpr;
    },
    Bind1: function () {
        return bindBExpr;
    }
};
var bindBExpr = {
    bind: function (v) {
        return function (v1) {
            if (v instanceof Application) {
                return new Application({
                    "function": Control_Bind.bind(bindBExpr)(v["value0"]["function"])(v1),
                    argument: Control_Bind.bind(bindBExpr)(v.value0.argument)(v1)
                });
            };
            if (v instanceof Abstraction) {
                return new Abstraction({
                    variableName: v.value0.variableName,
                    body: subst(monadBExpr)(v1)(v.value0.body)
                });
            };
            if (v instanceof FreeVariable) {
                return v1(v.value0);
            };
            throw new Error("Failed pattern match at Bounded (line 79, column 1 - line 84, column 32): " + [ v.constructor.name, v1.constructor.name ]);
        };
    },
    Apply0: function () {
        return $lazy_applyBExpr(0);
    }
};
var applicativeBExpr = /* #__PURE__ */ (function () {
    return {
        pure: FreeVariable.create,
        Apply0: function () {
            return $lazy_applyBExpr(0);
        }
    };
})();
var $lazy_applyBExpr = /* #__PURE__ */ $runtime_lazy("applyBExpr", "Bounded", function () {
    return {
        apply: Control_Monad.ap(monadBExpr),
        Functor0: function () {
            return functorBExpr;
        }
    };
});
var applyBExpr = /* #__PURE__ */ $lazy_applyBExpr(73);
var abstract1 = /* #__PURE__ */ Bound.abstract1(Data_Eq.eqString)(monadBExpr);
var altNComp = function (dictAlt) {
    var altCompose = Data_Functor_Compose.altCompose(dictAlt);
    var functorNComp1 = functorNComp(dictAlt.Functor0());
    return function (dictFunctor) {
        var alt = Control_Alt.alt(altCompose(dictFunctor));
        var functorNComp2 = functorNComp1(dictFunctor);
        return {
            alt: function (preferred) {
                return function (fallback) {
                    return alt(unwrap(preferred))(unwrap(fallback));
                };
            },
            Functor0: function () {
                return functorNComp2;
            }
        };
    };
};
var plusNComp = function (dictPlus) {
    var plusCompose = Data_Functor_Compose.plusCompose(dictPlus);
    var altNComp1 = altNComp(dictPlus.Alt0());
    return function (dictFunctor) {
        var altNComp2 = altNComp1(dictFunctor);
        return {
            empty: Control_Plus.empty(plusCompose(dictFunctor)),
            Alt0: function () {
                return altNComp2;
            }
        };
    };
};
var alternativeNComp = function (dictAlternative) {
    var applicativeNComp1 = applicativeNComp(dictAlternative.Applicative0());
    var plusNComp1 = plusNComp(dictAlternative.Plus1());
    return function (dictApplicative) {
        var applicativeNComp2 = applicativeNComp1(dictApplicative);
        var plusNComp2 = plusNComp1((dictApplicative.Apply0()).Functor0());
        return {
            Applicative0: function () {
                return applicativeNComp2;
            },
            Plus1: function () {
                return plusNComp2;
            }
        };
    };
};
var unRan = function (v) {
    return v;
};
var unDensity = function (v) {
    return v;
};
var unCodensity = function (v) {
    return v;
};
var runLanF = function (pt) {
    return function (v) {
        return v.extract(pt(v.seed));
    };
};
var runLan = function (nt) {
    return function (v) {
        return Data_Exists.runExists(runLanF(nt))(v);
    };
};
var ranCodensity = function ($522) {
    return MkRan(unCodensity($522));
};
var monadTrandCodensity = {
    lift: function (dictMonad) {
        var $523 = Control_Bind.bind(dictMonad.Bind1());
        return function ($524) {
            return MkCodensity($523($524));
        };
    }
};
var mkLanF = function (seed) {
    return function (extract) {
        return {
            extract: extract,
            seed: seed
        };
    };
};
var pureLanF = function (dictApplicative) {
    var $525 = mkLanF(Control_Applicative.pure(dictApplicative)(Data_Unit.unit));
    return function ($526) {
        return $525(Data_Function["const"]($526));
    };
};
var mkLan = function (seed) {
    var $527 = mkLanF(seed);
    return function ($528) {
        return MkLan(Data_Exists.mkExists($527($528)));
    };
};
var mapLanF = function (fun) {
    return function (v) {
        return mkLanF(v.seed)(function ($529) {
            return fun(v.extract($529));
        });
    };
};
var lowerRan = function (dictApplicative) {
    var $530 = Ran["lower$prime"](dictApplicative);
    return function ($531) {
        return $530(unRan($531));
    };
};
var lowerRan1 = /* #__PURE__ */ lowerRan(Data_Identity.applicativeIdentity);
var hproject = function (dict) {
    return dict.hproject;
};
var hhylo = function (dictHFunctor) {
    var hmap = FixFunctor.hmap(dictHFunctor);
    return function (c) {
        return function (a) {
            var r = function (x) {
                return a(hmap(r)(c(x)));
            };
            return r;
        };
    };
};
var hfold = function (dictNested) {
    var hmap = FixFunctor.hmap(dictNested.HFunctor0());
    var hproject1 = hproject(dictNested);
    return function (a) {
        var f = function (x) {
            return a(hmap(f)(hproject1(x)));
        };
        return f;
    };
};
var hembed = function (dict) {
    return dict.hembed;
};
var hunfold = function (dictNested) {
    var hembed1 = hembed(dictNested);
    var hmap = FixFunctor.hmap(dictNested.HFunctor0());
    return function (c) {
        var u = function (x) {
            return hembed1(hmap(u)(c(x)));
        };
        return u;
    };
};
var hdestroy = function (dictNested) {
    var hproject1 = hproject(dictNested);
    return function (u) {
        return u(hproject1);
    };
};
var hbuild = function (dictNested) {
    var hembed1 = hembed(dictNested);
    return function (f) {
        return f(hembed1);
    };
};
var gunfold = function (dictNested) {
    var hunfold1 = hunfold(dictNested);
    return function (ca) {
        return function (seed) {
            var $532 = hunfold1(ca);
            var $533 = mkLan(seed);
            return function ($534) {
                return $532($533($534));
            };
        };
    };
};
var gfold = function (dictNested) {
    var hfold1 = hfold(dictNested);
    return function (a) {
        var $535 = hfold1(a);
        return function ($536) {
            return unRan($535($536));
        };
    };
};
var funfold = function (dictNested) {
    var gunfold1 = gunfold(dictNested);
    var hmap = FixFunctor.hmap(dictNested.HFunctor0());
    return function (ca) {
        return function (s) {
            return gunfold1((function () {
                var $537 = hmap(unDensity);
                return function ($538) {
                    return $537(ca(MkDensity($538)));
                };
            })())(s)(unwrap);
        };
    };
};
var functorLan = {
    map: function (fun) {
        return function (v) {
            return Data_Exists.runExists((function () {
                var $539 = mapLanF(fun);
                return function ($540) {
                    return Data_Exists.mkExists($539($540));
                };
            })())(v);
        };
    }
};
var map3 = /* #__PURE__ */ Data_Functor.map(functorLan);
var functorDensity = {
    map: function (f) {
        return function (m) {
            return map3(f)(m);
        };
    }
};
var map4 = /* #__PURE__ */ Data_Functor.map(functorDensity);
var fmap = function (dict) {
    return dict.fmap;
};
var mapNested = function (dictNested) {
    var hembed1 = hembed(dictNested);
    var hmap = FixFunctor.hmap(dictNested.HFunctor0());
    var gfold1 = gfold(dictNested);
    return function (dictFFunctor) {
        var fmap1 = fmap(dictFFunctor)(functorRan);
        return function (f) {
            return function (x) {
                var mapAlg = function (t) {
                    return function (e) {
                        return hembed1(hmap(lowerRan1)(fmap1(function ($541) {
                            return unwrap(e($541));
                        })(t)));
                    };
                };
                return gfold1(mapAlg)(x)(function ($542) {
                    return Data_Identity.Identity(f($542));
                });
            };
        };
    };
};
var ffold = function (dictNested) {
    var hfold1 = hfold(dictNested);
    return function (a) {
        return function (t) {
            return unwrap(unCodensity(hfold1(a)(t))(Data_Const.Const));
        };
    };
};
var ffold1 = /* #__PURE__ */ ffold(nestedBExprBExprF);
var dupDensity = function (dx) {
    var mkDensity = function (extract) {
        return function (seed) {
            return Data_Exists.mkExists({
                extract: extract,
                seed: seed
            });
        };
    };
    var v = unDensity(dx);
    return Data_Exists.runExists(function (v1) {
        return mkDensity(mkDensity(v1.extract))(v1.seed);
    })(v);
};
var extendDensity = {
    extend: function (fd) {
        var $543 = map4(fd);
        return function ($544) {
            return $543(dupDensity($544));
        };
    },
    Functor0: function () {
        return functorDensity;
    }
};
var displayBExpr = function (displayFree) {
    var d = function (f) {
        var df = function (v) {
            if (v instanceof FreeVariable) {
                var dfv = function (v2) {
                    if (v2 instanceof Data_Either.Left) {
                        return v2.value0;
                    };
                    if (v2 instanceof Data_Either.Right) {
                        return Halogen_HTML_Elements.span([ Halogen_HTML_Properties.class_("bounded-variable") ])([ Halogen_HTML_Core.text(show(v2.value0.value0) + (" (" + (v2.value0.value1 + ")"))) ]);
                    };
                    throw new Error("Failed pattern match at Bounded (line 422, column 7 - line 422, column 29): " + [ v2.constructor.name ]);
                };
                return dfv(f(v.value0));
            };
            if (v instanceof Abstraction) {
                var displayVar = function (v1) {
                    if (v1 instanceof Bound.B) {
                        return new Data_Either.Right(new Data_Tuple.Tuple(0, v.value0.variableName));
                    };
                    if (v1 instanceof Bound.F) {
                        return new Data_Either.Left(d((function () {
                            var $545 = map1(first(function (v2) {
                                return v2 + 1 | 0;
                            }));
                            return function ($546) {
                                return $545(f($546));
                            };
                        })())(v1.value0));
                    };
                    throw new Error("Failed pattern match at Bounded (line 435, column 7 - line 435, column 60): " + [ v1.constructor.name ]);
                };
                return Halogen_HTML_Elements.div([ Halogen_HTML_Properties.class_("bounded-abstraction") ])([ Halogen_HTML_Elements.span([ Halogen_HTML_Properties.class_("bounded-scope-label") ])([ Halogen_HTML_Core.text("Scope of " + v.value0.variableName) ]), Halogen_HTML_Elements.div([ Halogen_HTML_Properties.class_("bounded-scope") ])([ d(displayVar)(Bound.unScope(v.value0.body)) ]) ]);
            };
            if (v instanceof Application) {
                return Halogen_HTML_Elements.div([ Halogen_HTML_Properties.class_("bounded-application") ])([ Halogen_HTML_Elements.div([ Halogen_HTML_Properties.class_("bounded-function") ])([ df(v["value0"]["function"]) ]), Halogen_HTML_Elements.div([ Halogen_HTML_Properties.class_("bounded-argument") ])([ df(v.value0.argument) ]) ]);
            };
            throw new Error("Failed pattern match at Bounded (line 419, column 5 - line 419, column 40): " + [ v.constructor.name ]);
        };
        return df;
    };
    return d(function ($547) {
        return Data_Either.Left.create(displayFree($547));
    });
};
var comonadDensity = {
    extract: /* #__PURE__ */ (function () {
        var $548 = runLan(identity);
        return function ($549) {
            return $548(unDensity($549));
        };
    })(),
    Extend0: function () {
        return extendDensity;
    }
};
var codensityRan = function ($550) {
    return MkCodensity(unRan($550));
};
var boundsCheckClosed = /* #__PURE__ */ (function () {
    var alg = function (v) {
        if (v instanceof Expr.ApplyF) {
            return new Application(v.value0);
        };
        if (v instanceof Expr.LambdaF) {
            return new Abstraction({
                variableName: v.value0.binder,
                body: abstract1(v.value0.binder)(v.value0.body)
            });
        };
        if (v instanceof Expr.VariableF) {
            return new FreeVariable(v.value0);
        };
        throw new Error("Failed pattern match at Bounded (line 344, column 9 - line 348, column 39): " + [ v.constructor.name ]);
    };
    return Matryoshka_Fold.cata(Expr.recursiveExprExprF)(alg);
})();
var boundsChecker = /* #__PURE__ */ (function () {
    var handleQuery = function (v) {
        var bound = boundsCheckClosed(v.value0);
        return discard(put(new Data_Maybe.Just(bound)))(function () {
            return pure(Data_Maybe.Just.create(v.value1(bound)));
        });
    };
    return Halogen_Component.mkComponent({
        initialState: Data_Function["const"](Data_Maybe.Nothing.value),
        render: function (mExpr) {
            return Halogen_HTML_Elements.div([ Halogen_HTML_Properties.class_("bounds-checker") ])(Data_Maybe.maybe([  ])((function () {
                var $551 = displayBExpr(function (unbound) {
                    return Halogen_HTML_Elements.span([ Halogen_HTML_Properties.class_("unbound-variable") ])([ Halogen_HTML_Core.text(unbound) ]);
                });
                return function ($552) {
                    return pure1($551($552));
                };
            })())(mExpr));
        },
        "eval": Halogen_Component.mkEval({
            initialize: Data_Maybe.Nothing.value,
            receive: Data_Function["const"](Data_Maybe.Nothing.value),
            handleAction: Data_Function["const"](pure(Data_Unit.unit)),
            handleQuery: handleQuery,
            finalize: Data_Maybe.Nothing.value
        })
    });
})();
var applyLanF = function (dictFunctor) {
    var map5 = Data_Functor.map(dictFunctor);
    return function (dictApply) {
        var apply = Control_Apply.apply(dictApply);
        var map6 = Data_Functor.map(dictApply.Functor0());
        return function (v) {
            return function (v1) {
                return mkLanF(apply(map6(Data_Tuple.Tuple.create)(v.seed))(v1.seed))(function (ft) {
                    return v.extract(map5(Data_Tuple.fst)(ft))(v1.extract(map5(Data_Tuple.snd)(ft)));
                });
            };
        };
    };
};
var applyLan = function (dictFunctor) {
    var applyLanF1 = applyLanF(dictFunctor);
    return function (dictApply) {
        var applyLanF2 = applyLanF1(dictApply);
        return {
            apply: function (v) {
                return function (v1) {
                    return Data_Exists.runExists(function (lff) {
                        return Data_Exists.runExists((function () {
                            var $553 = applyLanF2(lff);
                            return function ($554) {
                                return Data_Exists.mkExists($553($554));
                            };
                        })())(v1);
                    })(v);
                };
            },
            Functor0: function () {
                return functorLan;
            }
        };
    };
};
var applyDensity = function (dictApply) {
    var apply = Control_Apply.apply(applyLan(dictApply.Functor0())(dictApply));
    return {
        apply: function (df) {
            var $555 = apply(unDensity(df));
            return function ($556) {
                return MkDensity($555(unDensity($556)));
            };
        },
        Functor0: function () {
            return functorDensity;
        }
    };
};
var applyCodensity = {
    apply: function (f) {
        return function (x) {
            return Codensity.apply(unCodensity(f))(unCodensity(x));
        };
    },
    Functor0: function () {
        return functorCodensity;
    }
};
var bindCodensity = {
    bind: function (x) {
        return function (f) {
            return Codensity.bind(unCodensity(x))(function (y) {
                return unCodensity(f(y));
            });
        };
    },
    Apply0: function () {
        return applyCodensity;
    }
};
var applicativeLan = function (dictFunctor) {
    var applyLan1 = applyLan(dictFunctor);
    return function (dictApplicative) {
        var applyLan2 = applyLan1(dictApplicative.Apply0());
        return {
            pure: (function () {
                var $557 = pureLanF(dictApplicative);
                return function ($558) {
                    return MkLan(Data_Exists.mkExists($557($558)));
                };
            })(),
            Apply0: function () {
                return applyLan2;
            }
        };
    };
};
var applicativeDensity = function (dictApplicative) {
    var Apply0 = dictApplicative.Apply0();
    var applyDensity1 = applyDensity(Apply0);
    return {
        pure: (function () {
            var $559 = Control_Applicative.pure(applicativeLan(Apply0.Functor0())(dictApplicative));
            return function ($560) {
                return MkDensity($559($560));
            };
        })(),
        Apply0: function () {
            return applyDensity1;
        }
    };
};
var applicativeCodensity = {
    pure: function ($561) {
        return MkCodensity(Codensity.pure($561));
    },
    Apply0: function () {
        return applyCodensity;
    }
};
var pure2 = /* #__PURE__ */ Control_Applicative.pure(applicativeCodensity);
var monadCodensity = {
    Applicative0: function () {
        return applicativeCodensity;
    },
    Bind1: function () {
        return bindCodensity;
    }
};
var instantiate1 = /* #__PURE__ */ Bound.instantiate1(monadCodensity);
var nameBounded = function (i) {
    return function (b) {
        var runCodensityConst = function (cod) {
            var $562 = unCodensity(cod);
            return function ($563) {
                return unwrap($562($563));
            };
        };
        var alg = function (v) {
            if (v instanceof AppF) {
                var codensity = function (f) {
                    var runExpr = function (cca) {
                        return runCodensityConst(cca)(f);
                    };
                    return new Expr.Application({
                        "function": runExpr(v["value0"]["function"]),
                        argument: runExpr(v.value0.argument)
                    });
                };
                return codensity;
            };
            if (v instanceof AbsF) {
                var codensity = function (f) {
                    var var0 = Data_Function["const"](new Expr.Variable(v.value0.variableName));
                    var body = runCodensityConst(instantiate1(var0)(hoistScope(lowerCoyoneda)(v.value0.body)))(f);
                    return new Expr.Abstraction({
                        binder: v.value0.variableName,
                        body: body
                    });
                };
                return codensity;
            };
            if (v instanceof VarF) {
                return pure2(v.value0);
            };
            throw new Error("Failed pattern match at Bounded (line 361, column 9 - line 384, column 21): " + [ v.constructor.name ]);
        };
        return ffold1(alg)(map2(function ($564) {
            return Expr.Variable.create(i($564));
        })(b));
    };
};
var nameClosed = /* #__PURE__ */ nameBounded(Data_Void.absurd);
var nameNamed = /* #__PURE__ */ nameBounded(identity);
var nameCheckClosed = function (x) {
    return eq1(x)(nameNamed(boundsCheckClosed(x)));
};
var print = function (printIdent) {
    var $565 = nameBounded(printIdent);
    return function ($566) {
        return Expr.print($565($566));
    };
};
export {
    fmap,
    hembed,
    hproject,
    Application,
    Abstraction,
    FreeVariable,
    AppF,
    AbsF,
    VarF,
    hhylo,
    MkNComp,
    hfold,
    hbuild,
    hunfold,
    hdestroy,
    MkRan,
    unRan,
    lowerRan,
    MkLanF,
    mkLanF,
    runLanF,
    mapLanF,
    applyLanF,
    pureLanF,
    MkLan,
    mkLan,
    runLan,
    MkCodensity,
    unCodensity,
    ranCodensity,
    codensityRan,
    MkDensity,
    unDensity,
    dupDensity,
    gfold,
    gunfold,
    ffold,
    funfold,
    mapNested,
    boundsCheckClosed,
    nameBounded,
    nameClosed,
    nameNamed,
    nameCheckClosed,
    print,
    displayBExpr,
    BoundsCheck,
    boundsChecker,
    genericBExpr_,
    eq1BExpr,
    eqBExpr,
    functorBExpr,
    foldableBExpr,
    traversableBExpr,
    showBExpr,
    applyBExpr,
    applicativeBExpr,
    bindBExpr,
    monadBExpr,
    genericBExprF_,
    eq1BExprF,
    eqBExprF,
    functorBExprF,
    hFunctorBExprF,
    genericNComp_,
    newtypeNComp_,
    eq1NComp,
    eqNComp,
    functorNComp,
    applyNComp,
    applicativeNComp,
    altNComp,
    plusNComp,
    alternativeNComp,
    hFunctorNComp,
    nestedConstNComp,
    nestedBExprBExprF,
    functorRan,
    functorLan,
    applyLan,
    applicativeLan,
    functorCodensity,
    applyCodensity,
    applicativeCodensity,
    bindCodensity,
    monadCodensity,
    monadTrandCodensity,
    functorDensity,
    extendDensity,
    comonadDensity,
    applyDensity,
    applicativeDensity,
    fFunctorBExprF
};
//# sourceMappingURL=index.js.map
